import { Moment } from 'moment'

import { ReportValue, Team } from '@driftt/api-types'

export interface FilterState {
  timePeriod: ITimePeriod
  advancedFilters
  botStatus?: BotStatus
  widgetStatus?: string
  agentsSelected: { value: ReportValue }[]
  inboxSelected?: number
  teamSelected?: Team[]
  workspaceSelected?: string
  workspaceAgents?: { value: ReportValue }[]
  teammateEmailSelected?: any
  selectedClassificationId?: number
  automationPlaybookSelected?: any
  compoundFilter?: any
  compoundQuery?: any
}

export enum BotStatus {
  ALL = 'ALL',
  BOT_ASSISTED = 'BOT_ASSISTED',
  BOT_ONLY = 'BOT_ONLY',
  HUMAN_ONLY = 'HUMAN_ONLY',
  NO_RESPONSE = 'NO_RESPONSE',
}

export interface ITimePeriod {
  startDate: Moment
  endDate: Moment
  prevStart: Moment
  prevEnd: Moment
}

export const WidgetStatus = Object.freeze({
  ONLINE: false,
  OFFLINE: true,
})

export interface IFilterState {
  timePeriod: ITimePeriod
  botStatus?: BotStatus
  widgetStatus?: boolean
  agentsSelected?: any[]
  workspaceAgents?: any[]
  inboxSelected?: any[]
  teamSelected?: Team
  selectedClassificationId?: number
  hasWorkspacesManagementCutover?: boolean
}
